import React from 'react';
import { Ticket, ArrowRight } from 'lucide-react';
import { ThunderCountdown } from './ThunderCountdown';

const TICKETS_URL = 'https://www.tixtree.com/e/threads-of-thunder-indigenous-fashion-show-4e2c30e8d7e5';

export const ThunderTickets = () => (
  <div className="relative mt-8 rounded-2xl border border-yellow-500/40 bg-zinc-950/70 backdrop-blur-xl p-6 shadow-[0_0_40px_rgba(255,215,0,0.15)] overflow-hidden" data-testid="thunder-tickets-box">
    <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-yellow-500/20 blur-3xl pointer-events-none" />
    <div className="relative flex flex-col sm:flex-row sm:items-center gap-5">
      <div className="w-14 h-14 shrink-0 rounded-xl bg-yellow-500/15 border border-yellow-500/40 flex items-center justify-center mx-auto sm:mx-0">
        <Ticket className="w-7 h-7 text-yellow-400" />
      </div>
      <div className="flex-1 text-center sm:text-left">
        <p className="text-yellow-400 text-xs font-bold uppercase tracking-[0.25em] mb-1">Tickets on sale now</p>
        <h3 className="text-2xl font-bold text-white heading-oswald uppercase leading-tight">Threads of Thunder Fashion Show</h3>
        <p className="text-gray-400 text-sm mt-1">Nov 20, 2026 · 5PM - 8PM · Santa Rosa Fairgrounds</p>
      </div>
      <a href={TICKETS_URL} target="_blank" rel="noopener noreferrer" data-testid="thunder-get-tickets-btn"
        className="group inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-yellow-400 to-amber-500 text-black font-bold uppercase tracking-wider px-7 py-4 shadow-[0_0_25px_rgba(255,215,0,0.5)] hover:shadow-[0_0_40px_rgba(255,215,0,0.8)] hover:-translate-y-0.5 transition-[transform,box-shadow]">
        Get Tickets <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
      </a>
    </div>
    <div className="relative mt-6 pt-6 border-t border-yellow-500/20">
      <ThunderCountdown />
    </div>
  </div>
);
